import { CheckCircle2 } from "lucide-react";
import type { ReactNode } from "react";
import { Button } from "@/shared/ui/button";

/** Beküldés utáni visszajelzés a panelben — minden beküldő űrlap (tapasztalat, válasz,
 *  vélemény, olvasnivaló, hibajegyzék) ezt mutatja siker után, hogy a beküldő tudja: a
 *  beküldés megérkezett, és mi lesz vele. A „Rendben" zárja a panelt. */
export function ThankYou({
  title,
  children,
  onDone,
}: {
  title: string;
  children: ReactNode;
  onDone: () => void;
}) {
  return (
    <div role="status" className="flex flex-col items-center gap-3 py-2 text-center">
      <CheckCircle2 size={40} className="text-gold" aria-hidden />
      <p className="text-[17px] font-extrabold leading-tight">{title}</p>
      <p className="text-[15px] leading-[1.5] text-muted">{children}</p>
      <Button block size="lg" onClick={onDone}>
        Rendben
      </Button>
    </div>
  );
}
